import React from 'react';
import { Wand2 } from 'lucide-react';

// Click-to-insert token list shared by folder + file naming editors.
export const TokenChips = ({ tokens, onInsert }) => (
  <aside data-testid="drive-token-chips" className="bg-white border border-[#E2E2DF] rounded-md p-4 h-fit lg:sticky lg:top-4">
    <div className="flex items-center gap-2 mb-2">
      <Wand2 size={15} className="text-[#D35400]" />
      <div className="text-sm font-semibold text-slate-800">Fields</div>
    </div>
    <p className="text-[11px] text-slate-500 mb-3">Click to insert into the box you last clicked.</p>
    <div className="flex flex-col gap-1 max-h-[60vh] overflow-y-auto pr-1">
      {tokens.map((t) => (
        <button
          key={t.token}
          type="button"
          data-testid={`drive-token-${t.token.replace(/[{}]/g, '')}`}
          onMouseDown={(e) => e.preventDefault()}
          onClick={() => onInsert(t.token)}
          className="text-left flex items-center justify-between gap-2 px-2 py-1 rounded border border-transparent hover:border-[#D35400]/40 hover:bg-[#FFF7EC] transition-colors"
        >
          <div className="min-w-0">
            <div className="text-[11px] font-mono text-[#D35400] truncate">{t.token}</div>
            <div className="text-[10px] text-slate-500 truncate">{t.label}</div>
          </div>
          <div className="text-[10px] text-slate-400 font-mono truncate max-w-[90px]">{t.example}</div>
        </button>
      ))}
    </div>
  </aside>
);

// Insert `token` at the caret of the focused input and return the new value.
export const insertAtCaret = (el, value, token) => {
  if (!el) return (value || '') + token;
  const start = el.selectionStart ?? (value || '').length;
  const end = el.selectionEnd ?? start;
  const next = (value || '').slice(0, start) + token + (value || '').slice(end);
  requestAnimationFrame(() => { el.focus(); el.setSelectionRange(start + token.length, start + token.length); });
  return next;
};
